import { Button } from "@towersystems/roam-common-native";
import { Colors, View, Text, Spacings } from "react-native-ui-lib";
import { useCartContextProvider } from "../../hooks";
import { moneyToFormattedString } from "@towersystems/roam-common/lib/shared-utils";
import { useTranslation } from "../../../../../../utilities/i18n";

export const Footer = () => {
  const { t } = useTranslation("pos");
  const { sale, balance, totalItems, navigation, disabled } =
    useCartContextProvider();

  let buttonTitle;

  if (sale.isRefund) {
    buttonTitle = t("common:refund");
  } else {
    buttonTitle = t("common:pay");
    if (sale.isClosed) {
      buttonTitle = t("button:complete_sale");
    }
  }

  if (sale?.isLayby) {
    buttonTitle = t("button.complete_layby");
  }
  if (sale?.isQuote) {
    buttonTitle = t("button.complete_quote");
  }
  if (sale?.isInvoice) {
    buttonTitle = t("button.complete_invoice");
  }

  return (
    <View paddingT-10>
      <Button
        backgroundColor={Colors.action}
        onPress={() => navigation.navigate("CheckoutRootScreen")}
        disabled={disabled}
      >
        <View
          style={{
            justifyContent: "space-between",
            flexDirection: "row",
            flex: 1,
            width: "100%",
            alignItems: "center",
            opacity: disabled ? 0.4 : 1,
          }}
        >
          <View row style={{ alignItems: "center" }}>
            <Text
              color={disabled ? Colors.text : Colors.white}
              style={{ fontSize: 22, fontWeight: "bold" }}
            >
              {buttonTitle}
            </Text>
            <Text
              style={{
                paddingLeft: Spacings.s4,
                color: disabled ? Colors.text : Colors.white,
                opacity: 0.5,
              }}
            >
              {totalItems == 1 ? `(1 item)` : `(${totalItems} items)`}
            </Text>
          </View>
          <Text
            color={disabled ? Colors.text : Colors.white}
            style={{ fontSize: 22 }}
          >
            {moneyToFormattedString(balance || 0)}
          </Text>
        </View>
      </Button>
    </View>
  );
};
